import { useMergeRefs } from '@floating-ui/react';
import { HTMLProps, Ref, cloneElement, isValidElement } from 'react';
import * as tooltipStyles from './tooltip.css';
import { useTooltipContext } from './useTooltipContext';

interface ITooltipTriggerProps extends HTMLProps<HTMLElement> {
  asChild?: boolean;
  ref?: Ref<HTMLElement>;
}

export const TooltipTrigger = ({
  children,
  asChild = false,
  ref: forwardedRef,
  ...props
}: ITooltipTriggerProps) => {
  const { open, refs, getReferenceProps } = useTooltipContext();
  const childrenRef = (children as any).ref;
  const ref = useMergeRefs([refs.setReference, forwardedRef, childrenRef]);
  const dataState = open ? 'open' : 'closed';

  if (asChild && isValidElement(children)) {
    return cloneElement(
      children,
      getReferenceProps({
        ref,
        ...props,
        ...(children.props as any),
        'data-state': dataState,
      })
    );
  }

  return (
    <div
      className={tooltipStyles.triggerWrapper}
      ref={ref}
      data-state={dataState}
      {...getReferenceProps(props)}>
      {children}
    </div>
  );
};
